import { Hint } from '@factorialco/deprecated-design-system'
import { LOCAL_STORAGE_KEYS_FACTORIAL_TIPS } from 'config/Vars'

import { observer } from 'mobx-react'

import { useFeatures } from 'modules/core/hooks/useFeatures'
import i18n from 'modules/core/lib/i18n'
import useLocalStorage from 'modules/core/lib/useLocalStorage'

import imgStep1 from './assets/step1.png'
import imgStep2 from './assets/step2.png'
import imgStep3 from './assets/step3.png'

const ActionsPromotionModal = () => {
  const [workflowActionsPromoted, setWorkflowActionsPromoted] = useLocalStorage<boolean>(
    LOCAL_STORAGE_KEYS_FACTORIAL_TIPS.hideWorkflowsActionsPromotionHint,
    false
  )

  const { has_dev_workflows_actions: actionsEnabled } = useFeatures(['dev_workflows_actions'])

  if (workflowActionsPromoted || !actionsEnabled) return null

  const onClose = () => {
    setWorkflowActionsPromoted(true)
  }

  return (
    <>
      <Hint.NewModal onClose={onClose} onFinish={onClose}>
        <Hint.NewModal.ImageStep
          src={imgStep1}
          title={i18n.t('processes.process_settings.actions.promotion_modal.step_1.title')}
          description={i18n.t(
            'processes.process_settings.actions.promotion_modal.step_1.description'
          )}
        />
        <Hint.NewModal.ImageStep
          src={imgStep2}
          title={i18n.t('processes.process_settings.actions.promotion_modal.step_2.title')}
          description={i18n.t(
            'processes.process_settings.actions.promotion_modal.step_2.description'
          )}
        />
        <Hint.NewModal.ImageStep
          src={imgStep3}
          title={i18n.t('processes.process_settings.actions.promotion_modal.step_3.title')}
          description={i18n.t(
            'processes.process_settings.actions.promotion_modal.step_3.description'
          )}
        />
      </Hint.NewModal>
    </>
  )
}

export default observer(ActionsPromotionModal)
